import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { vitalUnitListEmpty, vitalUnitListMetric, vitalUnitListUS } from "../../Components/Constants";
import PracticeDetailsPrintPopup from "../../Components/PracticeDetailsPrintPopup";
import FormatPhoneNumber from "../../../../../../../../../utils/FormatPhoneNumber";
import SignImagePreview from "../../Components/SignImagePreview";
import DropdownValueHandler from "../../../../../../../../shared/SuperSearch/DropdownValueHandler";
import { formatDateTimeWithAt } from "../../Components/FormatDateTimeWithAt";
import { HPI_GROUPS, isSignedOrToBeCoSigned, ROS_GROUPS } from "../../Components/utils";
import CustomTemplateFormPreview from "../../Components/Custom Template Form/CustomTemplateFormPreview";
import EncDateStatus from "../../Components/Encounter Print Popup/EncDateStatus";
import SignData from "../../Components/SignData";

const SelectedPreviewDataV2 = ({ selectedItems, data, Data, searchParam, searchValue, ...props }) => {
  let { showAddressTypeLocation } = props;

  // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  // let vitalData = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
  //     acc[curr.VitalName] = curr.VitalValue;
  //     return acc;
  // }, {});

  let systemVitals = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
    acc[curr.VitalName] = curr.VitalValue;
    return acc;
  }, {});
  let vitalData = Data?.vitalData?.reduce((acc, curr) => {
    acc[curr.VitalName] = curr.VitalValue || systemVitals?.[curr.VitalName];
    return acc;
  }, {});

  const isVisuallyEmpty = (html = '') => {
    return html.replace(/<[^>]*>/g, '').trim() === '';
  }

  const removeTrailingEmptyLines = (html) => {
    return html.replace(/(<p><br><\/p>\s*)+$/g, '');
  }

  let noValExistTextNA = <p className="ar-light-color text">N/A</p>;
  let noValExistText = <p className="ar-light-color text">No data recorded</p>;
  console.log("AssesmentNotesAssesmentNotes", Data)
  let otherNoteText = removeTrailingEmptyLines(Data?.OtherNote || '');
  let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

  let historyOfPresentIllnessData = Data?.HistoryOfPresentIllness;
  let reviewOfSystemData = Data?.ReviewOfSystem;

  let historyofPresentIllnessNotesText = removeTrailingEmptyLines(Data?.HistoryofPresentIllnessNotes || '');
  let reviewOfSystemNotesText = removeTrailingEmptyLines(Data?.ReviewOfSystemNotes || '');
  let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');


  const vitalUnitListPreview = useMemo(() => {
    if (searchParam?.VitalUnitType === "US Customary") {
      return vitalUnitListUS;
    } else if (searchParam?.VitalUnitType === "Metric") {
      return vitalUnitListMetric;
    }
    return vitalUnitListEmpty; // fallback empty object
  }, [searchParam?.VitalUnitType]);

  const formattedUTC = data?.Data?.CurrentPracticeTime;
  let signatureDateTimeFormatted = formatDateTimeWithAt(data?.Data?.ProviderSignatureDate)
  let formattedUTCBottom = formattedUTC?.replace(',', ' at');
  const CustomTemplateData = Data?.CustomTemplateData?.[0];
  const EncounterCoSignData = Data?.EncounterCoSignData?.filter(enc => [ true, "true"].includes(enc.isCoSigned));
      const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
  return (<>
    {/* {selectedItems?.patientSummary && */}
    <div className='d-flex flex-column gap-10 mb-15'>
      {/* <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light">
          <p className="text fs-11 ar-light-color">{formattedUTC}</p>
          <p className='text fs-11 ar-light-color'>{data?.Data?.UserName ? `(${data?.Data?.UserName})` : ''} {data?.Data?.PracticeShortName}</p>
        </div> */}
      <div className="d-flex align-items-center justify-content-center gap-12 pat-det-header">
        <div className="d-flex align-items-center gap-1">
          <p className='heading text-white'>{data?.Data?.PatientName}</p>
          <p className='text text-white'>{data?.Data?.DOB}</p>
          <p className='text text-white'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</p>
          <p className='text text-white'>{data?.Data?.Gender}</p>
        </div>
        <div className="text light-clrs">|</div>
        <div className="d-flex align-items-center gap-1">
          <p className='text font-m text-white'>Account #</p>
          <p className="text text-white">{data?.Data?.AccountNumber || noValExistTextNA}</p>
        </div>
        <div className="text light-clrs">|</div>
        <div className="d-flex align-items-center gap-1">
          <p className='text font-m text-white'>DOS:</p>
          <p className="text text-white">{searchParam?.EncounterDate || noValExistTextNA}</p>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        {console.log("dataqwertData", data?.Data)}
        <PracticeDetailsPrintPopup data={data?.Data} />
      </div>
      <div className=''>
        <div className="encounter-edit-mode-pdf p-2 d-flex flex-column gap-1">
          <div className="col-md-12 p-0 d-flex gap-1">
            <p className="heading validate-color fs-16 lh-15">{data?.Data?.PatientName}</p>
            <span className='d-flex gap-1 align-items-center'>
              <span className='text text-black'>{data?.Data?.DOB}</span> <span className='text text-black'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</span> <span className='text text-black'>{data?.Data?.Gender}</span>
            </span>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column gap-1">
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Account #</p>
                <p className="text text-black">{data?.Data?.AccountNumber || noValExistTextNA}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Phone:</p>
                <p className="text text-black">{data?.Data?.MobileNumber ? FormatPhoneNumber(data?.Data?.MobileNumber) : noValExistTextNA}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Address:</p>
                <p className="text text-black">
                  {selectedItems?.patientSummary ?
                    (([true, "true"].includes(showAddressTypeLocation) ?
                      data?.Data?.FacilityAddress : data?.Data?.Address)
                      || noValExistTextNA) : noValExistTextNA}
                </p>
              </div>
            </div>

            <div className="d-flex flex-column gap-1">
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Provider:</p>
                <p className="heading validate-color">{searchValue.SeenBy || noValExistTextNA}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Insurance:</p>
                <p className="text text-black">{data?.Data?.InsuranceName || noValExistTextNA}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <p className="text font-m w-72px text-black">Location:</p>
                <p className="text text-black">{searchValue?.Facility || noValExistTextNA}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <EncDateStatus searchParam={searchParam} searchValue={searchValue} noValExistTextNA={noValExistTextNA} data={data} Data={Data}/>

        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center gap-1">
            <p className="heading validate-color">Encounter Type:</p>
            {searchValue?.EncounterType ?
              <span className="text validate-color">{searchValue.EncounterType}</span>
              :
              <>{noValExistTextNA}</>}
          </div>

          <div className="d-flex align-items-center gap-1">
            <p className="heading validate-color">Note Type:</p>
            {searchValue?.NoteType ?
              <span className="text validate-color">{searchValue.NoteType}</span>
              :
              <>{noValExistTextNA}</>}
          </div>
        </div>
      </div>
    </div>
    {/* } */}
    <div className="d-flex flex-column gap-10">
      {selectedItems?.customTemplateClinical &&
          (CustomTemplateData?.InsertPosition === "Top" ?
              <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
      {selectedItems?.chiefComplaint &&
        (<div className="d-flex flex-column gap-6">
          <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Chief Complaint</p>
          <div>
            <p className="text text-black">{Data?.ChiefComplaint || noValExistText}</p>
          </div>
        </div>)}

      {selectedItems?.historyofPresentIllness &&
        <div className="d-flex flex-column gap-6">
          <p className='text fs-14 font-b validate-color blue-bg w-max-content'>History of Present Illness(HPI)</p>
          {/* {["Fields","Both"].includes(selectedItems.historyofPresentIllnessType) && */}
          <div className="">
            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI</p>
            <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
              {(() => {
                const visibleGroups = HPI_GROUPS.map(group => ({
                  ...group,
                  selectedItems: group.items.filter(
                    item => historyOfPresentIllnessData?.[item.key] === "true"
                  ),
                })).filter(group => group.selectedItems.length > 0);

                return visibleGroups?.length > 0 ?
                  visibleGroups.map((group, groupIndex) => (
                    <React.Fragment key={group.title}>
                      {group.title}:{" "}
                      <span className="text">
                        {group.selectedItems.map((item, itemIndex) => (
                          <React.Fragment key={item.key}>
                            {item.label}
                            {itemIndex < group.selectedItems.length - 1 && ", "}
                          </React.Fragment>
                        ))}
                        {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                      </span>
                    </React.Fragment>
                  )) : noValExistText
              })()}
            </p>
          </div>
          {/* } */}
          {/* {["FreeText","Both"].includes(selectedItems.historyofPresentIllnessType) && */}
          <div>
            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI Notes</p>
            {isVisuallyEmpty(Data.HistoryofPresentIllnessNotes) ?
              noValExistText :
              <p className="text" dangerouslySetInnerHTML={{ __html: historyofPresentIllnessNotesText }}></p>}
          </div>
          {/* } */}
        </div>}
      {selectedItems?.reviewOfSystem &&
        <div className="d-flex flex-column gap-6">
          <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Review of System(ROS)</p>
          {/* {["Fields","Both"].includes(selectedItems.reviewOfSystemType) && */}
          <div className="">
            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>ROS Notes</p>
            <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
              {(() => {
                const visibleGroups = ROS_GROUPS.map(group => ({
                  ...group,
                  selectedItems: group.items.filter(
                    item => reviewOfSystemData?.[item.key] === "true"
                  ),
                })).filter(group => group.selectedItems.length > 0);

                return visibleGroups?.length > 0 ?
                  visibleGroups.map((group, groupIndex) => (
                    <React.Fragment key={group.title}>
                      {group.title}:{" "}
                      <span className="text">
                        {group.selectedItems.map((item, itemIndex) => (
                          <React.Fragment key={item.key}>
                            {item.label}
                            {itemIndex < group.selectedItems.length - 1 && ", "}
                          </React.Fragment>
                        ))}
                        {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                      </span>
                    </React.Fragment>
                  )) : noValExistText
              })()}
            </p>
          </div>
          {/* } */}
          {/* {["FreeText","Both"].includes(selectedItems.reviewOfSystemType) && */}
          <div>
            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>ROS Notes</p>
            {isVisuallyEmpty(Data.ReviewOfSystemNotes) ?
              noValExistText :
              <p className="text" dangerouslySetInnerHTML={{ __html: reviewOfSystemNotesText }}></p>}
          </div>
          {/* } */}
        </div>}

      {selectedItems?.vitals &&
        (<div className="d-flex flex-column gap-6 text-black">
          <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Vitals</p>
          <div className="">
            <p className='text text-black d-flex align-itemes-center gap-1 flex-wrap'>
              {(() => {
                const vitalItems = [
                  { key: "Height", label: "Height" },
                  { key: "Weight", label: "Weight" },
                  { key: "BMI", label: "BMI" },
                  { key: "BMI Percentile", label: "BMI Percentile" },
                  { key: "BP", label: "BP" },
                  { key: "Temperature", label: "Temperature" },
                  { key: "Pulse", label: "Pulse" },
                  { key: "Respiratory Rate", label: "Respiratory Rate" },
                  { key: "O2 Saturation", label: "O2 Saturation" },
                  { key: "Pain", label: "Pain" },
                  { key: "Head Circumference", label: "Head Circumference" },
                ];

                // Filter only those that have values
                const filledVitals = vitalItems.filter(v => vitalData?.[v.key]);
                if (filledVitals?.length === 0) return noValExistText;

                // Map them into JSX
                return filledVitals.map((v, index) => (
                  <React.Fragment key={v.key}>
                    {v.label}:{" "}
                    <span className="heading text-black">
                      {`${vitalData[v.key]} ${vitalUnitListPreview?.[v.key] || ""}`}
                    </span>
                    {index < filledVitals.length - 1 && ", "}
                  </React.Fragment>
                ));
              })()}
            </p>

          </div>
        </div>)}
      {selectedItems?.problems &&
        (<div className="d-flex flex-column gap-6">
          <p class="text fs-14 font-b validate-color blue-bg w-max-content">Problems</p>
          {Data?.EncounterProblem?.length > 0 ?

            <div className="d-flex flex-column gap-1">
              {Data.EncounterProblem.map((prob) => (
                <div className="d-flex align-items-center gap-1">
                  <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                  <p className="text text-black">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                  {prob.StartDate ?
                    (<div className="d-flex align-items-center gap-1">
                      <p className='heading text-black'>Start Date:</p>
                      <p className='text text-black'>{prob.StartDate || <span className="text fs-11 ar-light-color fst-italic">N/A</span>}</p>
                    </div>) : <></>}
                </div>
              )
              )}
            </div> :
            <>{noValExistText}</>}

        </div>)}
      {(selectedItems?.otherNote) &&
        (<div className="d-flex flex-column gap-6">
          <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Other Note</p>
          <div>
            {isVisuallyEmpty(otherNoteText) ?
              noValExistText :
              <p className="text text-black" dangerouslySetInnerHTML={{ __html: otherNoteText }}></p>}
          </div>
        </div>)}
        {selectedItems?.followUp &&
            <div className="d-flex flex-column gap-6">
                <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Follow-Up</p>
                {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                    noValExistText :
                    <div>
                        <div className="d-flex gap-1 text-nowrap mb-1">
                            <p className='heading'>Follow-Up Date:</p>
                            <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <p className='heading lh-12'>Notes:</p>
                            {isVisuallyEmpty(Data.FollowUpNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                        </div>
                    </div>
                }
            </div>
        }

      {selectedItems?.customTemplateClinical &&
          (CustomTemplateData?.InsertPosition === "Bottom" ?
              <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
      {(selectedItems?.additionalInfo || (selectedItems?.documents || selectedItems?.additionalNotes)) &&
        (<div className="d-flex flex-column gap-6">
          <div className="d-flex align-items-center justify-content-between">
              <p class="text fs-14 font-b validate-color blue-bg">Additional INFO</p>
          </div>
          {selectedItems?.documents &&
            <div>
              <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Documents</p>
              {Data?.EncounterDocument?.length > 0 ?
                <div className="d-flex flex-column gap-1">
                    {Data.EncounterDocument.map((doc) => (
                        <div className="d-flex align-items-center gap-1">
                            <p className='text font-m validate-color'>{doc.FileName}</p>
                            <p className="text text-black">{doc.Description && `- ${doc.Description}`}</p>
                        </div>
                    )
                    )}
                </div> :
                <>{noValExistText}</>}
            </div>}
          {selectedItems?.additionalNotes &&
            <div>
              <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
              <div>
                {isVisuallyEmpty(additionalNoteText) ?
                  noValExistText :
                  <p className="text text-black" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
              </div>
            </div>}
        </div>)}

      {selectedItems?.procedureCodes &&
        <div className="d-flex flex-column gap-6">
          <p class="text fs-14 font-b validate-color blue-bg w-max-content">Procedure Codes</p>
          {Data?.mainServiceLineModal?.length > 0 ?
            <div className="d-flex flex-column gap-1">
              {Data.mainServiceLineModal.map((data) => {
                let modifiersExists = [data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4].filter(Boolean)?.length > 0;
                return (
                  <div className="d-flex align-items-center gap-1 flex-wrap">
                    <p className='text font-m validate-color'>{data?.ProcedureCode}</p>
                    {data?.ProcedureDescription ? <p className="text text-black">{data?.ProcedureDescription && `- ${data.ProcedureDescription}`}</p> : null}
                    {modifiersExists ?
                      (<div className="d-flex align-items-center gap-1">
                        <p className="text text-black font-m">Modifiers:</p>
                        <p className="heading text-black">
                          {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                            .filter(Boolean).join(', ')}
                          {data?.Units && !['1', 1, '1.00'].includes(data.Units) && ', '}
                        </p>
                      </div>) : <></>}
                    {((data?.Units) && !['1', 1, "1.00"].includes(data.Units)) ?
                      (<div className="d-flex align-items-center gap-1">
                        <p className="text text-black font-m">Units:</p>
                        <p className="heading text-black">
                          {data?.Units}
                        </p>
                      </div>) : <></>}
                  </div>
                )
              }
              )}
            </div> :
            <>{noValExistText}</>}
        </div>}

      {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
        <div className="d-flex ">
          <div className="ar-sign-new-design d-flex flex-column gap-1">
            <div className="">
              <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
            </div>
            <p className="heading text-black">Electronically Signed By/Date:</p>
            <p className='heading green-text'>{data?.Data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
            {/* <div className="d-flex align-items-center gap-1">
              <p className='heading text-black'>Sign Off Status:</p>
              {(searchValue?.EncounterStatus === 'Signed' || isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus)) ?
                <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                searchValue?.EncounterStatus === 'In Progress' ?
                  <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                  searchValue?.EncounterStatus === 'Ready for Review' ?
                    <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                    ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                    <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}
            </div> */}
          </div>
        </div>
        :
        null}
                        
      {EncounterCoSignData?.map(it => 
          <SignData data={it}/>
      )}
      <div className='text-center pt-1-5 br-top-1 za_br_light'>
        <p className="text ar-light-color">Note Generated by {ThemeConfiguration?.configuration?.company?.name} (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer" >https://starhealthcare.co</a>) </p>
        {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTC}</p>
                <p className="text ar-light-color">Generated for Printing on: 11/6/2025 at 09:50 AM UTC</p> */}
        <p className="text ar-light-color">Printed by {data?.Data?.UserName || 'N/A'} on {formattedUTC}</p>
        {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTCBottom}</p> */}
      </div>

    </div >
  </>)
}

export default SelectedPreviewDataV2